import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd";
import { t } from "i18next";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { classNames } from "src/common/classNames";
import {
  ActivateCallback,
  useActivateCallback,
} from "src/types/ActivateCallback";

import { MdmUploadStore } from "../MdmUploadStore";
import * as styles from "./UploaderViewDefault.module.less";

type PropsUploaderViewDefault = {
  store: MdmUploadStore;
  activateCallback?: ActivateCallback;
  disabled?: boolean;
};

export const UploaderViewDefault: React.FC<PropsUploaderViewDefault> = observer(
  ({ store, activateCallback, disabled: disabledExt }) => {
    const {
      isImage,
      intFiles: fileList,
      maxCount,
      disabled: disabledInt,
    } = store;
    const disabled = disabledExt || disabledInt;
    const onOpen = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.stopPropagation();
      store.setModalOpen(true);
    };
    const refButton = useActivateCallback<HTMLDivElement>(
      activateCallback,
      (ref) => () => {
        ref?.focus();
      },
    );

    return (
      <div ref={refButton} className={styles.outer} tabIndex={-1}>
        {/* div avoids nested <button> warnings from Upload action controls */}
        <Upload
          className={classNames([
            [!isImage, styles.plmFileUploader],
            [
              fileList.length !== 0 && fileList.length < maxCount,
              styles.plmFileUploaderSpace,
            ],
            [fileList.length === 0, styles.plmImgUploaderStart],
          ])}
          fileList={fileList}
          onRemove={(file) => store.removeByUid(file.uid)}
          disabled={disabledExt}
        >
          {!disabled && fileList.length < maxCount && (
            <Button
              className={styles.fileUploadButton}
              icon={<UploadOutlined />}
              onClick={onOpen}
              color="blue"
              variant="solid"
            >
              {t("Upload")}
            </Button>
          )}
        </Upload>
      </div>
    );
  },
);
